;(() => {
  const CLEANUP_MS = 500

  function promptGoogleOneTap() {
    const googleId = window.google?.accounts?.id
    if (!googleId?.prompt) return

    if (!navigator.userAgent.includes("FxiOS")) {
      googleId.prompt()
      return
    }

    const errorCleanupTimerId = setTimeout(() => {
      googleId.cancel()
    }, CLEANUP_MS)

    googleId.prompt(() => {
      clearTimeout(errorCleanupTimerId)
    })
  }

  if (document.readyState === "complete") {
    promptGoogleOneTap()
  } else {
    window.addEventListener("load", promptGoogleOneTap)
  }

  window.HB = window.HB || {}
  window.HB.promptGoogleOneTap = promptGoogleOneTap
})()
